import styled from 'styled-components';
import Tooltip from 'react-simple-tooltip';

export const HotelPanelArticle = styled.article`
  position: sticky;
  z-index: 2;
  top: 120px;
  min-width: 315px;
  padding: 0 30px;
  padding-top: 55px;
  padding-bottom: 15px;

  background-color: ${({ theme }) => theme.white};

  @media(min-width: 768px) {
    padding-top: 50px;
    padding-bottom: 10px;

    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }

  @media(min-width: 1024px) {
    margin-bottom: 55px;
  }

  @media(max-height: 900px) {
    position: static;
  }
`;

export const ServiceFeeToolTip = styled(Tooltip)`
  z-index: 1;
  transform: none !important;
  position: absolute !important;

  margin-left: 10px;

  & > div:not(:first-child) {
    width: 230px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);

    div {
      text-align: left !important;
    }
  }
`;

export const QuestionTooltipBlock = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 16px !important;
  height: 16px;

  border-radius: 50%;

  text-align: center;
  color: ${({ theme }) => theme.black};
  font-size: 12px;
  background-color: ${({ theme }) => theme.lightGray};
`;

export const HotelPanelStatsContainer = styled.header`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 25px;
`;

export const HotelPanelPrice = styled.p`
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 24px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};

  span {
    font-size: 16px;
  }
  filter: blur(${ props  => props.blured ? '5px' : '0'});
`;

export const HotelCrossedPrice = styled.span`
  display: block;
  margin: 0;
  margin-bottom: 10px;
  padding: 0;

  font-weight: 400;
  color: ${({ theme }) => theme.black};
  font-size: 12px;
  text-decoration: line-through;

  @media(min-width: 700px) {
    font-size: 16px;
  }
`;

export const HotelPanelOldPrice = styled.span`
  display: block;
  margin: 0;
  padding: 5px 10px;

  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.black};

  background-color: ${({ theme }) => theme.yellow};
  border-radius: 50px;

  span {
    font-size: 21px;
  }

  @media(min-width: 700px) {
    padding: 5px 10px;
    font-size: 14px;
  }
`;

export const HotelPanelStats = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row-reverse;
`;

export const HotelPanelVotes = styled.span`
  margin-left: 5px;

  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
`;

export const HotelPanelBook = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 25px;
`;

export const HotelPanelNote = styled.p`
  margin: 0;
  margin-top: 15px;
  padding: 0;

  font-size: 12px;
  line-height: 1;
  text-align: center;
`;

export const HotelPanelTotalTable = styled.ul`
  width: 100%;

  font-size: 16px;
  line-height: 1;

  li {
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;

    filter: ${({ blurred }) => blurred ? 'blur(5px)' : 'none'};

    transition: filter 0.3s;

    p {
      margin: 0;
    }
  }

  li:last-child {
    border-top: 1px solid ${({ theme }) => theme.lightGray};
    margin-top: 10px;
    padding-top: 15px;
    padding-bottom: 20px;
  }

  div {
    &:first-child {
      flex-grow: 1;
    }

    &:last-child {
      text-align: right;
    }

    span {
      font-weight: 700;
      font-size: 24px;
    }
  }
`;

export const HotelPanelDescription = styled.p`
  margin: 0;
  padding: 0;

  font-size: 14px;
  line-height: 16px;
`;

export const HotelPanelFooter = styled.footer`
  display: flex;
  align-items: center;
  padding: 25px 0;
  padding-right: 25px;

  border-top: 1px solid ${({ theme }) => theme.lightGray};

  svg {
    margin-right: 25px;
    flex-shrink: 0;

    stroke: ${({ theme }) => theme.blue};
    fill: none;
  }
`;

export const HotelPanelFeatures = styled.div`
  position: relative;

  margin-bottom: 5px;

  border: 1px solid ${({ theme }) => theme.lightGray};
  border-radius: 6px;
`;

export const HotelPanelFeatureWrapper = styled.div`
  position: relative;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.lightGray};
  }
`;

export const HotelPanelFeature = styled.button`
  position: relative;

  width: 100%;
  padding: 20px;

  text-align: left;

  cursor: pointer;

  h3 {
    margin: 0;
    margin-bottom: 8px;
    padding: 0;

    font-weight: 400;
    font-size: 14px;
    line-height: 1;
  }

  .panel-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-weight: 700;

    svg {
      flex-shrink: 0;
    }
  }
`;

export const HotelPanelWarning = styled.div`
  position: absolute;
  z-index: 1;
  top: 103%;
  left: 0;

  width: 100%;
  padding: 10px 20px;

  font-size: 12px;
  color: ${({ theme }) => theme.white};

  background-color: ${({ theme }) => theme.blue};
  box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);
  border-radius: 6px;

  &::after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid ${({ theme }) => theme.blue};
  }
`;

export const HotelPanelWays = styled.button`
  width: 100%;
  padding: 15px 35px;

  font-weight: 400;
  font-size: 16px;
  text-align: left;

  transition: background-color 0.3s;

  &:hover {
    background-color: #f8f8f8;
  }
`;

export const HotelInfo = styled.div`
  display: flex;
  margin-bottom: 25px;
`;

export const HotelPhoto = styled.div`
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  margin-right: 15px;

  border-radius: 6px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;

    object-fit: cover;
  }
`;

export const HotelInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HotelFeaturesList = styled.ul`
  display: flex;
  flex-wrap: wrap;

  li {
    font-size: 12px;
    line-height: 1;

    &:not(:last-child) {
      position: relative;

      &::after {
        content: "";

        display: inline-block;
        vertical-align: middle;
        margin: 0 10px;
        width: 4px;
        height: 4px;

        background-color: #9a9a9a;
        border-radius: 50%;
      }
    }
  }
`;

export const ProductName = styled.p`
  margin: auto 0;
  padding: 0;

  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
`;

export const DatePickerWaitlist = styled.p`
  display: block;
  width: 180px;
  height: 50px;
  margin-left: 20px;
  margin-bottom: -30px;

  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.black};
`;

export const SignUpButton = styled.button`
  display: flex;
  align-items: center;

  font-weight: 700;
  font-size: 12px;
  line-height: 1;

  svg {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
`;

